import React from 'react'
import { CustomModalStyled, EduButton, FlexContainer } from '@edulastic/common'
import { confirmationDeleteRed, white } from '@edulastic/colors'
import styled from 'styled-components'
import i18translate from '@edulastic/localization'
import { languageByCode } from '@edulastic/constants/const/test'

const ClearContentConfirmationModal = ({
  handleModalResponse,
  showClearContentModal,
  primaryLanguage,
}) => {
  return (
    <CustomModalStyled
      title={i18translate.t(
        'author:multiLanguage.responseBoxChangeConfirmation.title'
      )}
      centered
      visible={showClearContentModal}
      onCancel={() => handleModalResponse('cancel')}
      footer={[
        <FlexContainer
          justifyContent="flex-end"
          alignItems="center"
          width="100%"
        >
          <EduButton
            isGhost
            data-cy="closeClearContentModal"
            onClick={() => handleModalResponse('cancel')}
          >
            {i18translate.t(
              'author:multiLanguage.responseBoxChangeConfirmation.buttonGroup.cancel'
            )}
          </EduButton>
          <EduButtonStyled
            data-cy="confirmClearContentModal"
            onClick={() => handleModalResponse('clear')}
          >
            {i18translate.t(
              'author:multiLanguage.responseBoxChangeConfirmation.buttonGroup.confirm'
            )}
          </EduButtonStyled>
        </FlexContainer>,
      ]}
    >
      <p>
        {`${i18translate.t(
          'author:multiLanguage.responseBoxChangeConfirmation.bodyText1'
        )} ${languageByCode[primaryLanguage]} ${i18translate.t(
          'author:multiLanguage.responseBoxChangeConfirmation.bodyText2'
        )}`}
      </p>
    </CustomModalStyled>
  )
}

export default ClearContentConfirmationModal

const EduButtonStyled = styled(EduButton)`
  &.ant-btn.ant-btn-primary {
    background-color: ${confirmationDeleteRed};
    border-color: ${confirmationDeleteRed};
    color: ${white};
    &.focus-visible,
    &:focus {
      outline: 0;
      box-shadow: 0 0 0 1px ${confirmationDeleteRed} !important;
    }
  }
`
